import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Blogscontent = () => {
  const location = useLocation();

  // Define a variable for each blog post to check if it's the current page
  const isCurrentPage1 = location.pathname === '/blog/medical-billing-vs-credentialing';
  const isCurrentPage2 = location.pathname === '/blog/outsourcing-medical-billing-benefits';
  const isCurrentPage3 = location.pathname === '/blog/medical-billing-to-boost-revenue';
  const isCurrentPage4 = location.pathname === '/blog/electronic-health-records-basics';
  const isCurrentPage5 = location.pathname === '/blog/revenue-cycle-management-tips';
  const isCurrentPage6 = location.pathname === '/blog/claims-processing-technology';
  const isCurrentPage7 = location.pathname === '/blog/best-medical-billing-company';
  const isCurrentPage8 = location.pathname === '/blog/patient-engagement-techniques';
  const isCurrentPage9 = location.pathname === '/blog/prevent-medical-billing-rejections';
  const isCurrentPage10 = location.pathname === '/blogs/what-billing-means-for-patients';
  const isCurrentPage11 = location.pathname === '/blog/healthcare-revenue-cycle-challenges';
  const isCurrentPage12 = location.pathname === '/blog/medical-billing-techniques';
  const isCurrentPage13 = location.pathname === '/blog/medical-billing-trends-2023-24';
  const isCurrentPage14 = location.pathname === '/blog/rcm-vs-health-informatics';
  const isCurrentPage15 = location.pathname === '/blog/healthcare-revenue-cycle-management';
  const isCurrentPage16 = location.pathname === '/blog/patient-data-protection';
  const isCurrentPage17 = location.pathname === '/blog/increase-healthcare-revenue';
  const isCurrentPage18 = location.pathname === '/blog/increase-healthcare-practice-revenue';
  const isCurrentPage19 = location.pathname === '/blog/medical-billing-trends-2025';
  const isCurrentPage20 = location.pathname === '/blog/reduce-claim-denials';
  const isCurrentPage21 = location.pathname === '/blog/medical-billing-services-for-small-practices';
  const isCurrentPage22 = location.pathname === '/blog/outsourcing-medical-billing-questions';
  const isCurrentPage23 = location.pathname === '/blog/Ultimate-Guide-to-Medical-Billing';
  const isCurrentPage24 = location.pathname === '/blog/denial-management-guide';
  const isCurrentPage25 = location.pathname === '/blog/medical-consultancy-services-benefits';
  const isCurrentPage26 = location.pathname === '/blog/medical-billing-services-guide';
  const isCurrentPage27 = location.pathname === '/blog/revenue-cycle-management-explained';
  const isCurrentPage28 = location.pathname === '/blog/types-of-medical-billing-and-rcm-impact';
  const isCurrentPage29 = location.pathname === '/blog/complete-billing-coding-usa';
  const isCurrentPage30 = location.pathname === '/blog/medical-billing-outsourcing-usa';
  const isCurrentPage31 = location.pathname === '/blog/medical-billing-coding-usa';
  const isCurrentPage32 = location.pathname === '/blog/medical-coding-services-usa';
  const isCurrentPage33 = location.pathname === '/blog/claim-denial-reasons-usa';
  const isCurrentPage34 = location.pathname === '/blog/medical-billing-process';
  const isCurrentPage35 = location.pathname === '/blog/revenue-cycle-vs-medical-billing';
  const isCurrentPage36 = location.pathname === '/blog/what-is-medical-billing';
  const isCurrentPage37 = location.pathname === '/blog/denial-codes-in-medical-billing';
  const isCurrentPage38 = location.pathname === '/blog/revenue-cycle-management-in-healthcare';
    const isCurrentPage39 = location.pathname === '/blog/medical-billing-services-for-healthcare-providers';
    const isCurrentPage40 = location.pathname === '/blog/in-house-vs-outsourced-medical-billing-cost-comparison';
      const isCurrentPage41 = location.pathname === '/blog/revenue-cycle-management-challenges-and-kpis';
  const isCurrentPage42 = location.pathname === '/blog/how-does-medical-billing-outsourcing-work';
    const isCurrentPage43 = location.pathname === '/blog/upstream-claim-scrubbing';



  return (
    <>
      <style>
        {`
          .table-of-contents ul li a {
            text-decoration: none;
            color: #007bff;
            transition: border-bottom 0.2s ease;
          }

          .table-of-contents ul li a:hover {
            text-decoration: underline;
          }
        `}
      </style>
      <div
        className="table-of-contents"
        style={{
          height: '500px', // Set the fixed height
          overflowY: 'auto', // Enable vertical scrolling,
          position: 'relative', // Ensures the content inside is positioned correctly
          paddingLeft: '50px',
          width: '85%',
        }}
      >
        <div
          style={{
            fontSize: '1.25rem',
            fontWeight: 'bold',
            borderBottom: '5px solid #007bff',
            paddingBottom: '5px',
            marginBottom: '15px',
            position: 'sticky', // Make the heading sticky at the top
            top: '0', // Stick to the top of the container
            zIndex: '1', // Make sure the heading stays on top of the scrollable list
            backgroundColor: '#f5f5f5',
            textAlign: 'center'
          }}
        >
          Table of Contents
        </div>
        <ul>
          {/* Conditional rendering based on current page */}
          {!isCurrentPage1 && (
            <li>
              <Link to="/blog/medical-billing-vs-credentialing">
                What’s the Difference Between Medical Billing and Credentialing
              </Link>
            </li>
          )}
          {!isCurrentPage2 && (
            <li>
              <Link to="/blog/outsourcing-medical-billing-benefits">
                Choosing to Outsource Your Medical Billing is a Smart decision?
              </Link>
            </li>
          )}
          {!isCurrentPage3 && (
            <li>
              <Link to="/blog/medical-billing-to-boost-revenue">
                Maximize Revenue and Minimize Hassles with AcerHealth Experts Medical Billing Services
              </Link>
            </li>
          )}
          {!isCurrentPage4 && (
            <li>
              <Link to="/blog/electronic-health-records-basics">
                Unveiling the Core Concepts of Electronic Health Records (EHRs)
              </Link>
            </li>
          )}
          {!isCurrentPage5 && (
            <li>
              <Link to="/blog/revenue-cycle-management-tips">
                Best Practices for Improving Revenue Cycle Management – AcerHealth
              </Link>
            </li>
          )}
          {!isCurrentPage6 && (
            <li>
              <Link to="/blog/claims-processing-technology">
                How to Accelerate Claims Processing Technology
              </Link>
            </li>
          )}
          {!isCurrentPage7 && (
            <li>
              <Link to="/blog/best-medical-billing-company">
                Obtain Billing Services from the Best Medical Billing Company
              </Link>
            </li>
          )}
          {!isCurrentPage8 && (
            <li>
              <Link to="/blog/patient-engagement-techniques">
                Techniques to Increase Patient Engagement
              </Link>
            </li>
          )}
          {!isCurrentPage9 && (
            <li>
              <Link to="/blog/prevent-medical-billing-rejections">
                How to Prevent Medical Billing Rejections
              </Link>
            </li>
          )}

          {!isCurrentPage10 && (
            <li>
              <Link to="/blogs/what-billing-means-for-patients">
                What Does Billing Mean to Patients
              </Link>
            </li>
          )}
          {!isCurrentPage11 && (
            <li>
              <Link to="/blog/healthcare-revenue-cycle-challenges">
                Challenges in Managing the Healthcare Revenue Cycle
              </Link>
            </li>
          )}
          {!isCurrentPage12 && (
            <li>
              <Link to="/blog/medical-billing-techniques">
                AcerHealth's Medical Billing Techniques
              </Link>
            </li>
          )}
          {!isCurrentPage13 && (
            <li>
              <Link to="/blog/medical-billing-trends-2023-24">
                Medical Billing Trends to Watch in 2024
              </Link>
            </li>
          )}
          {!isCurrentPage14 && (
            <li>
              <Link to="/blog/rcm-vs-health-informatics">
                Comparing Healthcare Revenue Cycle Management Vs. Health Informatics
              </Link>
            </li>
          )}
          {!isCurrentPage15 && (
            <li>
              <Link to="/blog/healthcare-revenue-cycle-management">
                Management Of the Healthcare Revenue Cycle
              </Link>
            </li>
          )}
          {!isCurrentPage16 && (
            <li>
              <Link to="/blog/patient-data-protection">
                Details about Patients is Protected by AcerHealth
              </Link>
            </li>
          )}
          {!isCurrentPage17 && (
            <li>
              <Link to="/blog/increase-healthcare-revenue">
                Potentially How Can We Increase Your Revenues
              </Link>
            </li>
          )}
          {!isCurrentPage18 && (
            <li>
              <Link to="/blog/increase-healthcare-practice-revenue">
                How Outsourcing Medical Billing Will Help Your Practice
              </Link>
            </li>
          )}
          {!isCurrentPage19 && (
            <li>
              <Link to="/blog/medical-billing-trends-2025">
                Top Medical Billing Trends in 2025: Future of Healthcare Finance
              </Link>
            </li>
          )}
          {!isCurrentPage20 && (
            <li>
              <Link to="/blog/reduce-claim-denials">
                Proven Ways to Reduce Medical Billing Claim Denials
              </Link>
            </li>
          )}
          {!isCurrentPage21 && (
            <li>
              <Link to="/blog/medical-billing-services-for-small-practices">
                Why Medical Billing Services Are a Game Changer for Small Practices
              </Link>
            </li>
          )}
          {!isCurrentPage22 && (
            <li>
              <Link to="/blog/outsourcing-medical-billing-questions">
                10 Questions to Ask Before Outsourcing Medical Billing Services for Better Revenue Cycle Management
              </Link>
            </li>
          )}
          {!isCurrentPage23 && (
            <li>
              <Link to="/blog/Ultimate-Guide-to-Medical-Billing">
                The Ultimate Guide to Medical Billing for Small Medical Practices in 2025
              </Link>
            </li>
          )}
          {!isCurrentPage24 && (
            <li>
              <Link to="/blog/denial-management-guide">
                Denial Management in Medical Billing: A Complete Guide for Healthcare Practices by Acer Health
              </Link>
            </li>
          )}
          {!isCurrentPage25 && (
            <li>
              <Link to="/blog/medical-consultancy-services-benefits">
                What Are Medical Consultancy Services and Why Your Practice Needs Them
              </Link>
            </li>
          )}
          {!isCurrentPage26 && (
            <li>
              <Link to="/blog/medical-billing-services-guide">
                A Comprehensive Guide to Medical Billing Services and Revenue Cycle Success
              </Link>
            </li>
          )}
          {!isCurrentPage27 && (
            <li>
              <Link to="/blog/revenue-cycle-management-explained">
                Revenue Cycle Management Explained: How It Can Transform Your Medical Practice
              </Link>
            </li>
          )}

          {!isCurrentPage28 && (
            <li>
              <Link to="/blog/types-of-medical-billing-and-rcm-impact">
                Types of Medical Billing and How They Impact Revenue Cycle Management
              </Link>
            </li>
          )}

          {!isCurrentPage29 && (
            <li>
              <Link to="/blog/complete-billing-coding-usa">
                Complete Billing and Coding Services for Medical Practices
              </Link>
            </li>
          )}


          {!isCurrentPage30 && (
            <li>
              <Link to="/blog/medical-billing-outsourcing-usa">
                Feeling the Billing Burden? Here’s How Outsourcing Can Strengthen Your Practice’s Finances
              </Link>
            </li>
          )}

          {!isCurrentPage31 && (
            <li>
              <Link to="/blog/medical-billing-coding-usa">
                Medical Billing and Coding: Key Differences and Why Both Are Essential
              </Link>
            </li>
          )}

          {!isCurrentPage32 && (
            <li>
              <Link to="/blog/medical-coding-services-usa">
                Medical Coding Services in the USA: Affordable Solutions for Small Practices
              </Link>
            </li>
          )}

          {!isCurrentPage33 && (
            <li>
              <Link to="/blog/claim-denial-reasons-usa">
                7 Common Reasons for Claim Denials in the U.S. and How to Prevent Them
              </Link>
            </li>
          )}

          {!isCurrentPage34 && (
            <li>
              <Link to="/blog/medical-billing-process">
                What Is the Medical Billing Process? Procedures, Steps & Workflow Simplified
              </Link>
            </li>
          )}

          {!isCurrentPage35 && (
            <li>
              <Link to="/blog/revenue-cycle-vs-medical-billing">
                Revenue Cycle Management vs. Medical Billing: What’s the Real Difference for Healthcare Providers in the USA?
              </Link>
            </li>
          )}

          {!isCurrentPage36 && (
            <li>
              <Link to="/blog/what-is-medical-billing">
                What Is Medical Billing? A Simple Guide for U.S. Healthcare Practices
              </Link>
            </li>
          )}

          {!isCurrentPage37 && (
            <li>
              <Link to="/blog/denial-codes-in-medical-billing">
                Top 20 Medical Billing Denial Codes in the USA: Meanings, Causes & Fixes
              </Link>
            </li>
          )}
     
          {!isCurrentPage38 && (
            <li>
              <Link to="/blog/revenue-cycle-management-in-healthcare">
                 What Is Revenue Cycle Management (RCM) in the Healthcare Industry?
              </Link>
            </li>
          )}

  {!isCurrentPage39 && (
            <li>
              <Link to="/blog/medical-billing-services-for-healthcare-providers">
                  Medical Billing Services: A Complete Guide for Healthcare Providers (2026)
                
              </Link>
            </li>
          )}

   {!isCurrentPage40 && (
            <li>
              <Link to="/blog/in-house-vs-outsourced-medical-billing-cost-comparison">
                  In-House vs. Outsourced Medical Billing: The True Cost Comparison for Healthcare Practices
              </Link>
            </li>
          )}


   {!isCurrentPage41 && (
            <li>
              <Link to="/blog/revenue-cycle-management-challenges-and-kpis">
                 Top Revenue Cycle Management Challenges and KPIs: How Healthcare Practices Improve Financial Performance
              </Link>
            </li>
          )}
            {!isCurrentPage42 && (
            <li>
              <Link to="/blog/how-does-medical-billing-outsourcing-work">
                 How Does Medical Billing Outsourcing Work? A Step-by-Step Guide
              </Link>
            </li>
          )}
           {!isCurrentPage43 && (
            <li>
              <Link to="/blog/upstream-claim-scrubbing">
                 Upstream Claim Scrubbing: How to Prevent Medical Billing Denials
              </Link>
            </li>
          )}


        </ul>
      </div>
      <div className="text-center p-3 " style={{ color: "#582C83" }}>
        <a
          class="btn btn-dark btn-floating btn-lg m-1"
          href=" https://www.facebook.com/acerhealth1"
          style={{ color: "#eaf1f9" }}
          target="_blank" rel="noopener noreferrer"
        >
          <i className="fab fa-2x fa-facebook-f"></i>
        </a>
        <a
          class="btn btn-dark btn-floating btn-lg m-1"
          href="https://twitter.com/AcerhealthL"
          style={{ color: "#eaf1f9" }}
          target="_blank" rel="noopener noreferrer"
        >
          <i className="fab fa-2x fa-twitter"></i>
        </a>
        <a
          class="btn btn-dark btn-floating btn-lg m-1"
          href="https://www.linkedin.com/company/acerhealth-inc/?viewAsMember=true"
          style={{ color: "#eaf1f9" }}
          target="_blank" rel="noopener noreferrer"
        >
          <i className="fab fa-2x fa-linkedin-in"></i>
        </a>
        <a
          class="btn btn-dark btn-floating btn-lg m-1"
          href="https://www.instagram.com/acerhealth_/"
          style={{ color: "#eaf1f9" }}
          target="_blank" rel="noopener noreferrer"
        >
          <i className="fab fa-2x fa-instagram"></i>

        </a>
      </div>
    </>
  );
};

export default Blogscontent;
